// Custom JS Application Code
function validate_email_js(email) { var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/; if(reg.test(email) == false) { return false; } return true; }
var ellipsisText = function (e, etc) { var wordArray = e.innerHTML.split(" "); while (e.scrollHeight > e.offsetHeight) { wordArray.pop(); e.innerHTML = wordArray.join(" ") + (etc || "..."); } };

function checkHeaderOffset() {
	var $window = $(window);
	var offset = $window.scrollTop();
	if (offset>=30) {
		$('#headerWrapper').addClass('scrolled');
	}else{
		$('#headerWrapper').removeClass('scrolled');
	}
}

function windowOnResize() {
	var myWidth, myHeight;
	if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
	else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
	else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
	browserWidth = myWidth;
	browserHeight = myHeight;
}
function pageScroll() {
	checkHeaderOffset();
}

function loadMorePosts() {
	if (!inAjax) {
		var action = 'load_more_posts';
		setLoadMorePosts();
		inAjax = true;
		$.ajax({ type: 'POST', url: js_vars.vars.ajaxurl, data: {
			'wpml_lang' : js_vars.vars.my_current_lang,
			'offset_counter' : js_vars.vars.offsetCounter,
			'num_page_items' : js_vars.vars.pageItems,
			'tag_id' : (tagID !== 0 ? tagID : ''),
			'cat_id' : (catID !== 0 ? catID : ''),
			'action': 'load_more_posts'
		}, success: function (result) {
			$('.articles-list-wrapper .articles-list').append(result.data.html);
			unsetLoadMorePosts();
			inAjax = false;
			js_vars.vars.offsetCounter += result.data.total;
			if (totalPosts<=js_vars.vars.offsetCounter) {
				$('.js-load-more-news').hide();
			}
		}, error: function () {} });
	}
}

function setLoadMorePosts() {
	$('.js-load-more-news').addClass('is-loading');
	$('.js-load-more-news').text(js_vars.vars.loadingStr);
}
function unsetLoadMorePosts() {
	$('.js-load-more-news').removeClass('is-loading');
	$('.js-load-more-news').text(js_vars.vars.loadMoreStr);
}



function scrollToSlide(slideTo) {
	$('body,html').animate({ scrollTop: $('.'+slideTo).offset().top-$('header').height() }, 800);
}

function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function checkEntryYoutubeVideos() {
	var iframes = document.getElementsByTagName('iframe');
	var key = /youtube.com/;
	for (var i = 0; i != iframes.length; ++i) {
		var match = iframes[i].src.search(key);
		if(match != -1) {
			$(iframes[i]).eq(0).addClass('video-player');
			$(iframes[i]).eq(0).closest('.with-iframe').addClass('video-wrapper');
		}
	}
}
function checkEntryVimeoVideos() {
	var iframes = document.getElementsByTagName('iframe');
	var key = /vimeo.com/;
	for (var i = 0; i != iframes.length; ++i) {
		var match = iframes[i].src.search(key);
		if(match != -1) {
			$(iframes[i]).eq(0).addClass('video-player');
			$(iframes[i]).eq(0).closest('.with-iframe').addClass('video-wrapper');
		}
	}
}
function onPlayerReady(event) {}

function onPlayerStateChange(event) {}

/* POPUP VIDEO YOUTUBE FUNCTIONS */
function onYouTubeIframeAPIReady() {
	$('.play-video').each(function() {
		var currentId = 1;//$(this).data('id');
		var videoId = $(this).data('video');
		videoPlayers.push(
			new YT.Player('video-player-'+currentId, {
				playerVars: { autoplay: 0, loop: 1, controls: 1, showinfo: 0, autohide: 1, modestbranding: 1, vq: 'hd1080'},
				videoId: videoId,
				events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
				}
			})
		);
	});
}
function pauseAllVideos() {
	$('.video-popup-wrapper').removeClass('video-playing');
	//$('.video-item a.js-open-video,.video-item .video-image').fadeIn();
	videoPlayers.forEach(function(item) {
		item.pauseVideo();
	});
}

// Variable needed for Youtube API
var done = false;

window.addEventListener('DOMContentLoaded', (event) => {
	(function($) {
		"use strict"; // Start of use strict
		$(window).bind('hashchange');
		$(window).trigger('hashchange');
		$(window).scroll( function() { /*disableScroll();*/ pageScroll(); } );
		$(window).resize(function() { windowOnResize(); });
		//$(window).ready(function() {
			var myWidth, myHeight;
			if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
			else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
			else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
			browserWidth = myWidth;
			browserHeight = myHeight;

			//if ($(window).width()>=1024) { new WOW().init(); }

			//$('.go-top a').click(function () { $('body,html').animate({ scrollTop: 0 }, 800); $(this).blur(); return false; });

			$('.entry-wysiwyg p iframe').closest('p').addClass('with-iframe');
			$('.entry-wysiwyg figure iframe').closest('figure').addClass('with-iframe');

			checkEntryYoutubeVideos();
			checkEntryVimeoVideos();

			$('.entry-wysiwyg p > img,.entry-wysiwyg p > video').closest('p').addClass('image-wrapper');
			$('.entry-wysiwyg p > img,.entry-wysiwyg p > video').addClass('responsive-full');

			$('.entry-wysiwyg figure > img:not(.alignleft,.alignright,.aligncenter),.entry-wysiwyg figure > a > img:not(.alignleft,.alignright,.aligncenter)').closest('figure').addClass('image-wrapper');
			$('.entry-wysiwyg figure > img:not(.alignleft,.alignright,.aligncenter),.entry-wysiwyg figure > a > img:not(.alignleft,.alignright,.aligncenter)').addClass('responsive-full');
			$('.entry-wysiwyg figure > video,.entry-wysiwyg figure > a > video').closest('figure').addClass('image-wrapper');
			$('.entry-wysiwyg figure > video,.entry-wysiwyg figure > a > video').addClass('responsive-full');

			$('.main-nav > li > ul').each(function() {
				$(this).addClass('is-submenu');
				$(this).closest('li').addClass('has-submenu');
			});

			$('.main-nav > li.has-submenu > a').bind('click',function(ev) {
				if (browserWidth<1024) {
					var headerWrapper = $('#headerWrapper');
					var mainNav = $('.main-nav');
					var parentLi = $(this).parent();
					if (parentLi.hasClass('in-submenu')) {
						headerWrapper.removeClass('in-submenu');
						mainNav.find('> li').show();
						parentLi.removeClass('in-submenu');
						parentLi.find('ul').hide();
					}else{
						headerWrapper.addClass('in-submenu');
						mainNav.find('> li').hide();
						parentLi.show();
						parentLi.addClass('in-submenu');
						parentLi.find('ul').show();
					}
				}else{
					var parentLi = $(this).parent();
					if (parentLi.hasClass('in-submenu')) {
						parentLi.removeClass('in-submenu');
						parentLi.find('ul').fadeOut();
					}else{
						$('.main-nav > li.in-submenu').each(function() {
							$(this).removeClass('in-submenu');
							$(this).find('ul').fadeOut();
						});
						parentLi.addClass('in-submenu');
						parentLi.find('ul').fadeIn();
					}
				}
				$(this).blur(); ev.preventDefault();
			});

			$('.js-category-toggle').bind('click',function(ev) {
				var parent = $(this).parent();
				parent.toggleClass('is-open');
				parent.find('ul').slideToggle();
				$(this).blur(); ev.preventDefault();
			});

			$('.js-scroll-news-banner').bind('click',function(ev) {
				var newsList = ($('.featured-article').length ? $('.featured-article') : $('.articles-list-wrapper'));
				if (newsList.length) {
					$('body,html').animate({ scrollTop: newsList.offset().top-$('header').height()-45 }, 800);
				}
				$(this).blur(); ev.preventDefault();
			});

			$('a.js-load-more-news').bind('click',function(ev) {
				loadMorePosts();
				$(this).blur(); ev.preventDefault();
			});

			$('.nav-toggle').bind('click',function(ev) {
				if ($('.nav-wrapper').hasClass('opened')) {
					$('.nav-wrapper').fadeOut(0,function() {
						$(this).removeClass('opened');
						$('#headerWrapper').removeClass('opened');
					});
					$(this).removeClass('is-active');
				}else{
					$('#headerWrapper').addClass('opened');
					$('.nav-wrapper').fadeIn(0,function() {
						$(this).addClass('opened');
					});
					$(this).addClass('is-active');
				}

				$(this).blur();
				ev.preventDefault();
			});

			$('.js-lang-toggle').bind('click',function(ev) {
				var parent = $(this).closest('.language-wrapper');
				parent.toggleClass('opened');
				parent.find('ul').slideToggle();
				$(this).blur(); ev.preventDefault();
			});

			$('.js-dealers-toggle').bind('click',function(ev) {
				var parent = $(this).closest('.dealers-filter');
				parent.toggleClass('opened');
				parent.find('ul').slideToggle();
				$(this).blur(); ev.preventDefault();
			});

			$('.js-dealers-load-more').bind('click',function(ev) {
				var showingAll = $(this).parent().hasClass('showing-all');
				if (!showingAll) {
					var moreItems = $('.dealers-list .item.to-show:not(.is-visible)');
					var countItems = 1;
					moreItems.each(function() {
						if (countItems<=8) { $(this).addClass('is-visible'); }
						countItems++;
					});
					if ($('.dealers-list .item.to-show:not(.is-visible)').length==0) {
						$(this).parent().addClass('showing-all');
					}
				}
				$(this).blur(); ev.preventDefault();
			});

			$('.dealers-filter ul.list li a').bind('click',function(ev) {
				var parent = $(this).closest('.dealers-filter');
				var dataCountry = parseInt($(this).data('country'),10);
				var allItems = $('.dealers-list .item');
				var listItems = allItems.filter('[data-country="'+dataCountry+'"]');

				$('.dealers-filter a.toggle').text($(this).text());
				parent.find('ul li').removeClass('active');
				$(this).parent().addClass('active');

				parent.toggleClass('opened');
				parent.find('ul').slideToggle();

				//change list
				$('.dealers-list .item').removeClass('is-visible');
				$('.dealers-list .item').removeClass('to-show');
				$('.dealers-list .item').css('display','');

				if (dataCountry==0) {
					allItems.addClass('to-show');
				}else{
					listItems.addClass('to-show');
					listItems.addClass('is-visible');
				}
				/*
				for (var i=1; i<=8; i++) {
					$('.dealers-list .item.to-show').eq(i-1).addClass('is-visible');
				}

				$('.js-dealers-load-more').parent().removeClass('showing-all');

				if ($('.dealers-list .item.to-show').length>8) {
					$('.js-dealers-load-more').parent().show();
				}else{
					$('.js-dealers-load-more').parent().hide();
				}
				*/

				$(this).blur(); ev.preventDefault();
			});

			$('.js-accordion-toggle').bind('click',function(ev) {
				var parent = $(this).closest('.accordion-item');
				parent.toggleClass('opened');
				parent.find('.accordion-content').slideToggle();
				$(this).blur(); ev.preventDefault();
			});

			$('.js-toggle-tab').bind('click',function(ev) {
				var parent = $(this).closest('.tabs-group');
				parent.find('.tab-item').removeClass('active');
				parent.find('.tabs-list li').removeClass('active');

				$(this).parent().addClass('active');
				$('#specificationsTab_'+$(this).data('tab')).addClass('active');

				$(this).blur(); ev.preventDefault();
			});

			$('.js-scroll-to-products-list').bind('click',function(ev) {
				var productsList = $('.products-list-wrapper');
				if (productsList.length) {
					$('body,html').animate({ scrollTop: productsList.offset().top-$('header').height()-45 }, 800);
				}
				$(this).blur(); ev.preventDefault();
			});

			$('.js-open-upgrade-info').bind('click',function(ev) {
				var parent = $(this).closest('.item');
				if (browserWidth<992) {
					parent.find('> .info').hide();
					parent.find('> .upgrade-info').show();
				}else{
					parent.find('> .upgrade-info').fadeIn();
				}
				$(this).blur(); ev.preventDefault();
			});

			$('.js-close-upgrade-info').bind('click',function(ev) {
				var parent = $(this).closest('.item');
				if (browserWidth<992) {
					parent.find('> .info').show();
					parent.find('> .upgrade-info').hide();
				}else{
					parent.find('> .upgrade-info').fadeOut();
				}
				$(this).blur(); ev.preventDefault();
			});

			$('.js-close-video').bind('click',function(ev) {
				pauseAllVideos();
				$(this).closest('.video-popup-wrapper').fadeOut();
				$('body').removeClass('in-popup');
				$(this).blur(); ev.preventDefault();
			});

			$('.js-open-video').bind('click',function(ev) {
				var currentId = 1;//$(this).data('id');
				var videoId = $(this).data('video');
				var videoItem = $('#video-popup-'+currentId);
				pauseAllVideos();
				videoPlayers[currentId-1].playVideo();
				videoItem.addClass('video-playing');
				videoItem.fadeIn();
				$('body').addClass('in-popup');
				$(this).blur(); ev.preventDefault();
			});

			$('.js-close-form-popup').bind('click',function(ev) {
				$(this).closest('.form-popup-wrapper').fadeOut();
				//$('body').removeClass('in-popup');
				$(this).blur(); ev.preventDefault();
			});

			$('.js-open-download-flyer-').bind('click',function(ev) {
				$('.form-popup-wrapper').fadeIn();
				//$('body').addClass('in-popup');
				$(this).blur(); ev.preventDefault();
			});

			if ($('.flyers-list-wrapper').length || $('.is-download-file').length) {
				if (typeof showGatedForm !== 'undefined' && showGatedForm) {
					var isDownloadAvailable = false; //to check if user already inserted a valid email
					var pageId = downloadPageId;
					var pageUrl = downloadPageUrl;
					var pageTitle = downloadPageTitle;
					var cookieDownloadEmail = Cookies.get('vtd_email');
					var cookieDownloadAvailable = Cookies.get('vtd_available');

					if (cookieDownloadAvailable=='available') {
						isDownloadAvailable = true;
					}else{
						//check if query var is equal to cookie page email
						//if it is, must set my other cookie and set cookie valid, if not, then, nothing to do here
						var queryEmailParam = getUrlParameter('email');
						if (queryEmailParam==cookieDownloadEmail) {
							var fileDownloadId = Cookies.get('vtd_email_file_id');
							Cookies.set('vtd_available', 'available', { expires: 180 });
							Cookies.set('vtd_email_file_id', 0, { expires: 180 });
							Cookies.set('vtd_email', '', { expires: 180 });
							isDownloadAvailable = true;
							if (fileDownloadId!='') {
								var url = $('#flyerFile'+fileDownloadId).attr('href');
								//window.location.href = url;
								window.open(url, '_blank').focus();
							}
						}
					}

					if (!isDownloadAvailable) {
						$('.flyers-list a').attr('href','#');
						$('.flyers-list a').attr('target','_self');
						$('a.is-download-file').attr('href','#');
						$('a.is-download-file').attr('target','_self');
						$('.js-open-download-flyer').bind('click',function(ev) {
							var machine_hubspot = $(this).data('machine_hubspot');
							downloadFileId = $(this).data('file-id');
							$('.form-popup-wrapper input[name=download-click-name]').val($(this).text());
							$('.form-popup-wrapper input[name=download-click-url]').val($(this).data('filename'));
							$('.form-popup-wrapper input[name=marktsegment]').val($(this).data('marktsegment_hubspot'));
							if (typeof machine_hubspot !== 'undefined') {
								$('.form-popup-wrapper input[name=machines]').val(machine_hubspot);
							}
							$('.form-popup-wrapper').fadeIn();
							$(this).blur(); ev.preventDefault();
						});
					}

					document.addEventListener( 'wpcf7mailsent', function( event ) {
						if ( downloadFormID == event.detail.contactFormId ) {
							var submittedEmail = '';
							var inputs = event.detail.inputs;
							for ( var i = 0; i < inputs.length; i++ ) {
								if ( 'email' == inputs[i].name ) {
									submittedEmail = inputs[i].value;
									break;
								}
							}
							//Cookies.set('vtd_email', submittedEmail, { expires: 180 }); //remove email verification
							//Cookies.set('vtd_email_file_id', downloadFileId, { expires: 180 }); //remove email verification
							//window.location.href = $('#flyerFile'+downloadFileId).data('href'); //remove email verification
							window.open($('#flyerFile'+downloadFileId).data('href'), '_blank').focus();
							downloadFileId = 0;
							$('.form-popup-wrapper input[name=download-click-name]').val('N/A');
							$('.form-popup-wrapper input[name=download-click-url]').val('N/A');
						}
					}, false );
				}
			}


		//});

		$(window).on('load',function() {
			if ($('.testimonials-slider').length) {
				new Swiper('.testimonials-slider .swiper-container', {
					autoHeight: false,
					slidesPerView: 'auto',
					spaceBetween: 0,
					loop: true,
					loopAdditionalSlides: 2,
					centeredSlides: true,
					navigation: {
						nextEl: '.testimonials-slider .swiper-testimonials-button-next',
						prevEl: '.testimonials-slider .swiper-testimonials-button-prev',
					},
					pagination: {
						el: '.testimonials-slider .swiper-custom-pagination',
						type: 'bullets',
						clickable: true,
					},
				});
			}

			if ($('.page-form-wrapper .form-wrapper input[name="marktsegment"]').length) {
				if (typeof marktsegment_hubspot !== 'undefined') {
					$('.page-form-wrapper .form-wrapper input[name="marktsegment"]').eq(0).val(marktsegment_hubspot);
				}
			}
			if ($('.page-form-wrapper .form-wrapper input[name="machines"]').length) {
				if (typeof machines_hubspot !== 'undefined') {
					$('.page-form-wrapper .form-wrapper input[name="machines"]').eq(0).val(machines_hubspot);
				}
			}
		});

	})(jQuery); // End of use strict
});


var browserWidth = 0;
var browserHeight = 0;
var videoPlayers = [];
var downloadFileId = 0;
var inAjax = false;
